import React from "react";
import clx from "classnames";
import Icon, { Icons } from "../../Icon/Icon";
import styles from "../styles/Input.module.css";

export interface InputProps {
    id?: string;
    name: string;
    label?: string;
    defaultValue?: string;
    value?: string;
    placeholder?: string;
    type?: "text" | "email" | "password" | "search";

    disabled?: boolean;
    error?: boolean;
    success?: boolean;
    required?: boolean;
    invertColors?: boolean;

    icon?: Icons;

    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input = ({
    id,
    name,
    label,
    placeholder,
    value,
    defaultValue,
    type = "text",
    disabled,
    success,
    error,
    invertColors,
    icon,
    required,

    onChange,
    onKeyDown,
    onBlur,
}: InputProps) => {
    const cnInput = clx(styles.input, {
        [styles.inputError]: error,
        [styles.inputDisabled]: disabled,
        [styles.inputInvertColor]: invertColors,
    });

    const showIcon = !error && !success && !!icon;

    return (
        <label htmlFor={id || name} className={styles.inputLabel}>
            {!!label && <span>{label}</span>}
            <div className={styles.inputWrap}>
                <input
                    id={id || name}
                    name={name}
                    type={type}
                    className={cnInput}
                    placeholder={placeholder}
                    value={value}
                    defaultValue={defaultValue}
                    required={required}
                    onChange={onChange}
                    onBlur={onBlur}
                    onKeyDown={onKeyDown}
                    disabled={disabled}
                />

                {!!error && (
                    <Icon
                        icon="error"
                        className={`text-plum-500 motion-safe:animate-drop-fade-in ${styles.inputIcon} pointer-events-none`}
                    />
                )}
                {!!success && (
                    <Icon
                        icon="success"
                        className={`text-mint-500 motion-safe:animate-drop-fade-in-out ${styles.inputIcon} pointer-events-none`}
                    />
                )}

                {showIcon ? <Icon icon="search" className={`${styles.inputIcon} pointer-events-none`} /> : null}
            </div>
        </label>
    );
};

export default Input;
